import React from 'react'
import ChevronArrow from '../../../assets/media/icons/icon-chevron-up.svg'
import { ReactComponent as CompletedMedalIcon } from '../../../assets/media/icons/ndq-mission-completed-medal.svg'
import { ReactComponent as FinalStepIcon } from '../../../assets/media/icons/icon-ndq-final-trophy.svg'
import { useTranslation } from 'react-i18next'
import importer from '@takedapdt/biolife-core/src/importer'
const { gameStepStatus } = importer('Constant/Utils', null)
import './styles.scss'

const GameCard = ({ title, completed, finalStep, totalPoints, actionType }) => {
  const { t, i18n } = useTranslation('LoyaltyGame')
  return (
    <div className={`game-card-container ${completed ? 'completed' : ''}`}>
      <div>
        {completed ? (
          <div></div>
        ) : (
          <div className='game-card-title'>
            {finalStep ? (
              <div className='game-card-final-step-title'>
                <span className='game-card-title'>{t('finalMission')}</span>
                <span className='game-card-final-step-points'>
                  {totalPoints} {t('points')}
                </span>
              </div>
            ) : (
              <span className='game-card-title'>{t('mission')}</span>
            )}
          </div>
        )}
        <div className='game-card-content-container'>
          {completed ? (
            <div className='game-card-complete-medal'>
              <CompletedMedalIcon width='30' height='30' />
            </div>
          ) : null}
          <div className='game-card-content'>{title}</div>
        </div>
      </div>
      <div className='game-icon-aligned'>
        {finalStep ? (
          <FinalStepIcon width='23' height='38' />
        ) : !finalStep &&
          ((actionType == gameStepStatus?.LOYALTY_ENROLLMENT && !completed) || actionType != gameStepStatus?.LOYALTY_ENROLLMENT) ? (
          <img className='game-card-arrow' width='16' height='16' src={ChevronArrow} />
        ) : null}
      </div>
    </div>
  )
}

export default GameCard
